<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>脚本创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/script')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <el-form
        :model="formData"
        label-width="110px"
        ref="formData"
        :rules="rules"
      >
        <el-form-item label="脚本名称" prop="scriptName">
          <el-input v-model="formData.scriptName"></el-input>
        </el-form-item>

        <el-form-item label="脚本示例" prop="inputExample">
          <el-input v-model="formData.inputExample"></el-input>
        </el-form-item>
        <el-form-item label="脚本内容" prop="scriptBody">
          <!-- <el-input v-model="formData.inputExample" ></el-input> -->
          <prism-editor
            class="my-editor height-300"
            v-model="formData.scriptBody"
            :highlight="highlighter"
            @change="codeChanged"
            :line-numbers="lineNumbers"
          ></prism-editor>
          <div style="margin-left: 20px" v-if="formData.testResult">
            {{ formData.testResult }}
          </div>
          <el-button
            @click="testCode"
            style="background-color: #9999ff; color: #fff"
            >运行测试</el-button
          >
        </el-form-item>

        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>创建</span>
          </el-button>
          <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="clearFn"
          >
            <!-- <i v-if="item.icon" :class="item.icon"></i> -->
            <span>重置</span>
          </el-button>
        </div>
      </el-form>
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addScript } from '@/api/scriptis'
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css' // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/themes/prism-tomorrow.css' // import syntax highlighting styles

export default {
  components: {
    PrismEditor
  },
  data() {
    return {
      lineNumbers: true, // true为编辑模式， false只展示不可编辑
      // 表单配置
      formData: {
        scriptName: '',
        inputExample: '',
        scriptBody: '',
        testResult: ''
      },
      rules: {
        scriptName: [
          { required: true, message: '脚本名称必填', trigger: 'blur' }
        ],
        inputExample: [
          { required: true, message: '脚本示例必填', trigger: 'blur' }
        ],
        scriptBody: [
          { required: true, message: '脚本内容必填', trigger: 'blur' }
        ]
      },
      formBtns: [
        {
          content: '创建',
          width: '185px',
          type: 'primary'
        },
        {
          content: '重置',
          width: '185px',
          type: ''
        }
      ]
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js) //returns html
    },
    codeChanged(_code) {
      window.console.log(_code)
    },
    // 运行测试代码
    testCode() {
      if (!this.formData.scriptBody) {
        this.$message({
          message: '脚本内容不能为空',
          type: 'error'
        })
        return
      }
      if (!this.formData.inputExample) {
        this.$message({
          message: '脚本示例不能为空',
          type: 'error'
        })
        return
      }
      let result = ''
      let testfunc
      let runstr = 'testfunc = function' + this.formData.scriptBody
      eval(runstr)
      result = testfunc(this.formData.inputExample)
      this.formData.testResult = result
      // this.$loading({
      //   text: '脚本运行中'
      // })
      // // let infos = JSON.parse(JSON.stringify(formData))
      // let runparams = {
      //   inputExample: this.formData.inputExample,
      //   scriptBody: this.formData.scriptBody
      //   // status: infos.status,
      //   // inputExample: infos.inputExample
      // }
      // runScript(runparams).then((res) => {
      //   console.log(res.data, '运行')
      //   if (res.code == 200) {
      //     this.testResult = res.data
      //     // this.$message({
      //     //   message: '添加成功',
      //     //   type: 'success'
      //     // })
      //     // this.$router.go(-1)
      //   } else {
      //     this.$message({
      //       message: res.data,
      //       type: 'error'
      //     })
      //   }
      // })
      // this.$loading().close()
    },
    clearFn() {
      this.testResult = ''
      this.$refs.formData.resetFields()
    },
    submitFn() {
      console.log(this.formData, '脚本创建')
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          // this.$emit('submit', this.formData)

          if (this.submited) return
          this.$loading({
            text: '脚本添加中'
          })
          let addparams = {
            scriptName: this.formData.scriptName,
            scriptBody: this.formData.scriptBody,
            // status: this.formData.status ? this.formData.status : 1,
            inputExample: this.formData.inputExample
          }
          addScript(addparams).then((res) => {
            console.log(res.data, '创建')
            if (res.code == 200) {
              this.submited = true
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.$router.go(-1)
            } else {
              this.$message({
                message: res.data,
                type: 'error'
              })
            }
          })
          this.$loading().close()
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* required class */
.my-editor {
  background: #2d2d2d;
  color: #ccc;

  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

/* optional */
.prism-editor__textarea:focus {
  outline: none;
}

/* not required: */
.height-300 {
  height: 300px;
}
</style>
